import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveEventAccountFromEventParticipantsMutationVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
  event_account_id: Types.Scalars['ID'];
}>;


export type RemoveEventAccountFromEventParticipantsMutation = { __typename?: 'Mutation', removeEventAccountFromEventParticipants: { __typename?: 'Event', id: string, name?: string | null } };


export const RemoveEventAccountFromEventParticipantsDocument = gql`
    mutation RemoveEventAccountFromEventParticipants($event_id: ID!, $event_account_id: ID!) {
  removeEventAccountFromEventParticipants(
    event_id: $event_id
    event_account_id: $event_account_id
  ) {
    id
    name
  }
}
    `;
export type RemoveEventAccountFromEventParticipantsMutationFn = Apollo.MutationFunction<RemoveEventAccountFromEventParticipantsMutation, RemoveEventAccountFromEventParticipantsMutationVariables>;

/**
 * __useRemoveEventAccountFromEventParticipantsMutation__
 *
 * To run a mutation, you first call `useRemoveEventAccountFromEventParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventAccountFromEventParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventAccountFromEventParticipantsMutation, { data, loading, error }] = useRemoveEventAccountFromEventParticipantsMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      event_account_id: // value for 'event_account_id'
 *   },
 * });
 */
export function useRemoveEventAccountFromEventParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventAccountFromEventParticipantsMutation, RemoveEventAccountFromEventParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventAccountFromEventParticipantsMutation, RemoveEventAccountFromEventParticipantsMutationVariables>(RemoveEventAccountFromEventParticipantsDocument, options);
      }
export type RemoveEventAccountFromEventParticipantsMutationHookResult = ReturnType<typeof useRemoveEventAccountFromEventParticipantsMutation>;
export type RemoveEventAccountFromEventParticipantsMutationResult = Apollo.MutationResult<RemoveEventAccountFromEventParticipantsMutation>;
export type RemoveEventAccountFromEventParticipantsMutationOptions = Apollo.BaseMutationOptions<RemoveEventAccountFromEventParticipantsMutation, RemoveEventAccountFromEventParticipantsMutationVariables>;